export default {
    header: {
        search: {
            en: 'Search',
            zh: '搜索'
        }
    },
    footer: {
        nav: {
            catalog: [
                {
                    title: {
                        en: 'DevNet',
                        zh: 'DevNet'
                    },
                    items: [
                        {
                            name: {
                                en: 'New Cisco Certifications',
                                zh: 'New Cisco Certifications'
                            },
                            url: '/certification/'
                        },
                        {
                            name: {
                                en: 'DevNet Automation Exchange',
                                zh: 'DevNet Automation Exchange',
                            },
                            url: '/network-automation/',
                        },
                        {
                            name: {
                                en: 'Sandbox',
                                zh: '沙盒'
                            },
                            url: '/site/sandbox/'
                        },
                        {
                            name: {
                                en: 'Learning Tracks',
                                zh: '学习版块'
                            },
                            url: 'https://developer.cisco.com/learning/tracks'
                        },
                        {
                            name: {
                                en: 'Code Exchange',
                                zh: 'Code Exchange'
                            },
                            url: 'https://developer.cisco.com/codeexchange/'
                        },
                        {
                            name: {
                                en: 'Video course',
                                zh: '视频教程'
                            },
                            url: 'https://developer.cisco.com/video/net-prog-basics/'
                        },
                        {
                            name: {
                                en: 'Videos',
                                zh: '视频'
                            },
                            url: 'https://developer.cisco.com/video/'
                        }
                    ]
                },
                {
                    title: {
                        en: 'Technologies',
                        zh: '技术'
                    },
                    items: [
                        {
                            name: {
                                en: 'IoT',
                                zh: '物联网'
                            },
                            url: '/iot/'
                        },
                        {
                            name: {
                                en: 'Cloud',
                                zh: '云'
                            },
                            url: '/site/cloud/'
                        },
                        {
                            name: {
                                en: 'Networking',
                                zh: '网络'
                            },
                            url: '/site/networking/'
                        },
                        {
                            name: {
                                en: 'Data Center',
                                zh: '数据中心'
                            },
                            url: '/site/data-center/'
                        },
                        {
                            name: {
                                en: 'Security',
                                zh: '安全'
                            },
                            url: '/site/security/'
                        },
                        {
                            name: {
                                en: 'Open Source',
                                zh: '开源'
                            },
                            url: '/site/opensource/'
                        },
                        {
                            name: {
                                en: 'Collaboration',
                                zh: '协作'
                            },
                            url: '/site/collaboration/'
                        },
                        {
                            name: {
                                en: 'Mobility',
                                zh: '移动'
                            },
                            url: '/site/mobility/'
                        }
                    ]
                },
                {
                    title: {
                        en: 'Cisco resources',
                        zh: '思科资源'
                    },
                    items: [
                        {
                            name: {
                                en: 'Cisco.com',
                                zh: '思科首页'
                            },
                            url: 'http://www.cisco.com/'
                        },
                        {
                            name: {
                                en: 'Cisco Partner Program',
                                zh: '思科合作伙伴项目'
                            },
                            url: 'https://www.cisco.com/c/en/us/partners/partner-with-cisco/developer.html'
                        },
                        {
                            name: {
                                en: 'Marketplace',
                                zh: '市场'
                            },
                            url: 'https://marketplace.cisco.com/catalog'
                        },
                        {
                            name: {
                                en: 'Cisco Support Community',
                                zh: '思科技术支持社区'
                            },
                            url: 'https://supportforums.cisco.com/'
                        },
                        {
                            name: {
                                en: 'Cisco Modeling Labs',
                                zh: '思科网络建模实验室'
                            },
                            url: '/modeling-labs/'
                        }
                    ]
                },
                {
                    title: {
                        en: 'Community',
                        zh: '社区'
                    },
                    items: [
                        {
                            name: {
                                en: 'Upcoming events',
                                zh: '近期活动'
                            },
                            url: '/events/'
                        },
                        {
                            name: {
                                en: 'Cisco DNA',
                                zh: '思科DNA'
                            },
                            url: '/site/dna-community/'
                        },
                        {
                            name: {
                                en: 'Diversity and inclusion',
                                zh: '多样性与包容性'
                            },
                            url: '/site/diversity-and-inclusion/'
                        },
                        {
                            name: {
                                en: 'Blogs',
                                zh: '博客'
                            },
                            url: 'https://blogs.cisco.com/developer'
                        },
                        {
                            name: {
                                en: 'Feedback',
                                zh: '反馈'
                            },
                            url: '/feedback'
                        },
                    ]
                },
            ],
            connect: {
                title: {
                    en: 'Stay connected',
                    zh: '关注我们'
                },
                twitter: {
                    en: 'Twitter',
                    zh: 'Twitter'
                },
                facebook: {
                    en: 'Facebook',
                    zh: 'Facebook'
                },
                instagram: {
                    en: 'Instagram',
                    zh: 'Instagram'
                },
                youtube: {
                    en: 'YouTube',
                    zh: 'YouTube'
                },
                github: {
                    en: 'GitHub',
                    zh: 'GitHub'
                },
            },
            newsletter: {
                title: {
                    en: 'Subscribe to our newsletter',
                    zh: '订阅我们的信息'
                },
                subtitle: {
                    en: 'News, specials, and promotions sent directly to your inbox',
                    zh: '将发送新闻、技术信息到你的邮箱'
                },
                placeholder: {
                    en: 'Enter your email address',
                    zh: '请输入你的邮箱'
                },
                subscribe: {
                    en: 'Subscribe',
                    zh: '订阅'
                },
                subscribeSuccess: {
                    en: 'Almost finished... We need to confirm your email address. To complete the subscription process, please click the link in the email we just sent you.',
                    zh: '即将订阅成功……我们需要您确认您的邮件地址, 请点击我们发送的邮件中的链接来完成订阅。'
                },
                subscribeDevnetUser: {
                    en: 'Almost finished... Please click the link in the email we just sent you. You can also edit your profile!',
                    zh: '即将订阅成功……请点击我们发送的邮件中的链接来完成订阅，你也可以在你的个人设置中更改。'
                },
                subscribeAlready: {
                    en: 'Thank you! You are already subscribed to our newsletter.',
                    zh: '谢谢您！您已经订阅了我们的邮件。'
                },
                subscribeFailed: {
                    en: 'Oops! Something wrong with the server, please try later.',
                    zh: '对不起，我们的服务器出现了问题，请稍后再试。'
                }
            }
        }
    },
    'discover': {
        "en": "Discover",
        "zh": "探索"
    },
    'technologies': {
        "en": "Technologies",
        "zh": "产品"
    },
    'community': {
        "en": "Community",
        "zh": "社区"
    },
    'events': {
        "en": "Events",
        "zh": "活动"
    },
    'new': {
        "en": "New Announcement",
        "zh": "最新动态"
    },
    signup: {
        "en": "Sign up free",
        "zh": "免费注册"
    },
    'login': {
        "en": "Log in",
        "zh": "登录"
    },
    'copyright': {
        "en": "© Copyright {year} Cisco DevNet"
    },
    'termsconditions': {
        "en": "Terms & Conditions",
        "zh": "重要声明"
    },
    'privacyctatement': {
        "en": "Privacy Statement",
        "zh": "保密声明"
    },
    'cookiepolicy': {
        "en": "Cookie Policy",
        "zh": "隐私权政策"
    },
    'trademarks': {
        "en": "Trademarks",
        "zh": "商标"
    },
    'reportissue': {
        "en": "Report a bug",
        "zh": "遇到问题"
    },
    'sitemap': {
        "en": "Sitemap",
        "zh": "Sitemap"
    },
    'devcenter': {
        "en": " Dev Center",
        "zh": "产品中心"
    },
    'gotodevcenter': {
        "en": "Go to Dev Center",
        "zh": "产品中心"
    },
    megamenu: {
        discover: [
            {
                name: {
                    en: 'Learn',
                    zh: '学习'
                },
                children: [
                    {
                        name: {
                            en: 'Learning Path',
                            zh: '学习之路'
                        },
                        url: 'https://developer.cisco.com/startnow/',
                        className: 'margin-top-8'
                    },
                    {
                        name: {
                            en: 'Learning Tracks',
                            zh: '学习版块'
                        },
                        url: 'https://developer.cisco.com/learning/tracks',
                        className: 'margin-top-12'
                    },
                    {
                        name: {
                            en: 'Video course',
                            zh: '视频教程'
                        },
                        url: 'https://developer.cisco.com/video/net-prog-basics/',
                        className: 'margin-top-12'
                    },
                    {
                        name: {
                            en: 'Videos',
                            zh: '视频'
                        },
                        url: 'https://developer.cisco.com/video/',
                        className: 'margin-top-12'
                    },
                    {
                        name: {
                            en: 'Certification',
                            zh: 'Certification'
                        },
                        className: 'margin-top-24 bold'
                    },
                    {
                        name: {
                            en: 'DevNet Certifications',
                            zh: 'DevNet Certifications'
                        },
                        url: '/certification/',
                        className: 'margin-top-12'
                    },
                    {
                        name: {
                            en: 'DevNet Associate Fundamentals Course',
                            zh: 'DevNet Associate Fundamentals Course'
                        },
                        url: '/certification/fundamentals/',
                        className: 'margin-top-12'
                    },
                    {
                        name: {
                            en: 'DevNet Associate Certification Guided Study Group',
                            zh: 'DevNet Associate Certification Guided Study Group'
                        },
                        url: '/certification/devasc-group/',
                        className: 'margin-top-12'
                    },
                    {
                        name: {
                            en: 'Specialization Program for Partners',
                            zh: 'Specialization Program for Partners'
                        },
                        url: '/partner/',
                        className: 'margin-top-12'
                    }
                ]
            },
            {
                name: {
                    en: 'Code',
                    zh: '代码'
                },
                children: [
                    {
                        name: {
                            en: 'Sandbox Remote Labs',
                            zh: '远程沙盒实验室',
                        },
                        description: {
                            en: 'Free 24x7 hosted labs for integrating and working with Cisco Technologies',
                            zh: '全天候免费宿主试验室，使用和集成思科技术'
                        },
                        url: '/site/devnet/sandbox/',
                        className: 'paragraph',
                    },
                    {
                        name: {
                            en: 'Code Exchange',
                            zh: 'Github上的源代码',
                        },
                        description: {
                            en: 'Discover, learn, and build on curated GitHub projects to jumpstart your work with Cisco platforms and APIs',
                            zh: '在Github上找到源代码，帮你开始使用思科服务接口'
                        },
                        url: 'https://developer.cisco.com/codeexchange/',
                        className: 'paragraph',
                    },
                    {
                        name: {
                            en: 'Build Applications with Cisco',
                            zh: '使用思科技术构建应用程序',
                        },
                        description: {
                            en: 'Discover new kinds of applications that can be built with Cisco APIs',
                            zh: '探索使用思科API构建的新型应用程序'
                        },
                        url: 'https://developer.cisco.com/appdev/',
                        className: 'paragraph',
                    },
                    {
                        name: {
                            en: 'Cisco Modeling Labs',
                            zh: '思科网络建模实验室',
                        },
                        description: {
                            en: 'Welcome to the world of network simulation',
                            zh: '欢迎来到网络模拟的世界'
                        },
                        url: '/modeling-labs/',
                        className: 'paragraph',
                    }
                ]
            },
            {
                name: {
                    'en': 'Inspire',
                    'zh': '启发'
                },
                children: [
                    {
                        name: {
                            en: 'DevNet Automation Exchange',
                            zh: 'DevNet Automation Exchange',
                        },
                        description: {
                            en: 'Shared code repositories of use cases for network automation',
                            zh: 'Shared code repositories of use cases for network automation'
                        },
                        url: '/network-automation/',
                        className: 'paragraph'
                    },
                ]
            },
            {
                name: {
                    'en': 'Connect',
                    'zh': '连接'
                },
                children: [
                    {
                        name: {
                            en: 'Browse Communities',
                            zh: '浏览社区',
                        },
                        url: '/site/coi/'
                    },
                    {
                        name: {
                            en: 'Events',
                            zh: '活动',
                        },
                        url: '/events/'
                    },
                    {
                        name: {
                            en: 'Partner Challenge',
                            zh: '合作伙伴挑战赛',
                        },
                        url: 'https://developer.cisco.com/partner-challenge/'
                    },
                    {
                        name: {
                            en: 'Cisco Innovation Centers',
                            zh: '思科创新中心',
                        },
                        url: '/site/innovation-centers/'
                    },
                    {
                        name: {
                            en: 'Latest Blogs',
                            zh: '最新博客',
                        },
                        url: 'https://blogs.cisco.com/developer'
                    },
                    {
                        name: {
                            en: 'DevNetZone at Cisco Live',
                            zh: 'Cisco Live上的DevNet区域',
                        },
                        url: 'https://www.ciscolive.com/us/activities/world-of-solutions/devnet-zone/'
                    },
                    {
                        name: {
                            en: 'DevNet Study Group Platform',
                            zh: 'DevNet Study Group Platform',
                        },
                        url: 'https://developer.cisco.com/studygroup/'
                    },/*
                    {
                        name: {
                            en: 'For Partners',
                            zh: 'For Partners'
                        },
                        className: 'margin-top-24 bold',
                        new: true
                    },
                    {
                        name: {
                            en: 'DevNet Partner Central',
                            zh: 'DevNet Partner Central'
                        },
                        url: '/partners/',
                        className: 'margin-top-12'
                    },
                    {
                        name: {
                            en: 'DevNet Specialization',
                            zh: 'DevNet Specialization'
                        },
                        url: '/partner/specialization/',
                        className: 'margin-top-12'
                    },
                    {
                        name: {
                            en: 'DevNet Marketplace',
                            zh: 'DevNet Marketplace'
                        },
                        url: '/site/marketplace/',
                        className: 'margin-top-12'
                    }*/
                ]
            }
        ],
        community: [
            {
                name: {
                    'en': 'Overview',
                    'zh': '概要'
                },
                description: {
                    en: 'Get connected with other Cisco technology experts in DevNet.',
                    zh: '与DevNet技术专家建立联系'
                },
                children: [
                    {
                        name: {
                            en: 'Community blogs',
                            zh: '社区博客',
                        },
                        url: 'https://blogs.cisco.com/developer',
                        className: 'check',
                    },
                    {
                        name: {
                            en: 'Developer forums',
                            zh: '开发者论坛',
                        },
                        url: 'https://community.cisco.com/t5/for-developers/ct-p/4409j-developer-home',
                        className: 'check',
                    },
                    {
                        name: {
                            en: 'Upcoming events',
                            zh: '近期活动',
                        },
                        url: '/events/',
                        className: 'check',
                    },
                    {
                        name: {
                            en: 'Follow us on Twitter',
                            zh: '我们的Twitter',
                        },
                        url: 'https://twitter.com/CiscoDevNet',
                        className: 'check',
                    },
                    {
                        name: {
                            en: 'Get Started',
                            zh: '开始',
                        },
                        url: '/site/coi/',
                        className: 'button',
                    }
                ]
            },
            {
                name: {
                    'en': 'Communities of Interest',
                    'zh': '社区版块'
                },
                children: [

                    {
                        name: {
                            en: 'Cisco Learning and Certifications',
                            zh: '思科认证',
                        },
                        url: '/site/cisco-certifications/'
                    },
                    {
                        name: {
                            en: 'Cisco + Splunk',
                            zh: '思科与Splunk',
                        },
                        url: '/site/splunk/'
                    },
                    {
                        name: {
                            en: 'Cisco Digital Network Architecture',
                            zh: '思科数字网络架构',
                        },
                        url: '/site/dna-community/'
                    },
                    {
                        name: {
                            en: 'Cisco Networking Academy',
                            zh: '思科网络研究院',
                        },
                        url: '/site/netacad/'
                    },
                    {
                        name: {
                            en: 'Cisco UI/UX Community',
                            zh: '思科UI/UX社区',
                        },
                        url: '/site/uiux/'
                    },
                    {
                        name: {
                            en: 'Design Thinking',
                            zh: '设计思维',
                        },
                        url: '/site/designthinking/'
                    },
                    {
                        name: {
                            en: 'View All',
                            zh: '查看所有',
                        },
                        url: '/site/coi/',
                        className: 'paragraph'
                    },
                ]
            },
            {
                name: {
                    'en': 'Community Support',
                    'zh': '社区支持'
                },
                children: [
                    {
                        name: {
                            en: 'Finesse',
                        },
                        url: 'https://communities.cisco.com/community/developer/finesse'
                    },
                    {
                        name: {
                            en: 'Automation and Analytics',
                        },
                        url: 'https://communities.cisco.com/community/developer/apic-em'
                    },
                    {
                        name: {
                            en: 'Mobility',
                        },
                        url: 'https://communities.cisco.com/community/developer/mobility-services-api'
                    },
                    {
                        name: {
                            en: 'Sandbox',
                            zh: '沙盒',
                        },
                        url: 'https://communities.cisco.com/community/developer/sandbox'
                    },
                    {
                        name: {
                            en: 'IOx',
                        },
                        url: 'https://communities.cisco.com/community/developer/networking/internet-of-things/iox'
                    },
                    {
                        name: {
                            en: 'WebEx Developer',
                            zh: 'WebEx开发者',
                        },
                        url: 'https://communities.cisco.com/community/developer/webex'
                    },
                    {
                        name: {
                            en: 'Security',
                        },
                        url: 'https://community.cisco.com/t5/developer-security/ct-p/j-developer-security'
                    },
                    {
                        name: {
                            en: 'View All',
                            zh: '查看所有',
                        },
                        url: 'https://communities.cisco.com/community/developer',
                        className: 'paragraph'
                    }
                ]
            },
            {
                name: {
                    'en': 'Blogs',
                    'zh': '博客'
                },
            }
        ]
    },
    agreeModal: {
        commitment: {
            en: 'I understand that violation of either of these policies is grounds for disciplinary action, up to and including termination of employment. There are no exceptions or justifications for any transactions that violate this policy.',
            zh: '我明白违反上述任何规定都会导致处理措施，严重者予以解雇处理，没有任何例外情况可以违反该规定!'
        },
        downLoad: {
            success: {
                title: {
                    en: 'Download Confirmation',
                    zh: '下载确认'
                },
                content: {
                    start: {
                        en: 'Thank you for agreeing to the required Terms and Conditions. Please click ',
                        zh: '感谢您赞同下载规则，请点击 '
                    },
                    here: {
                        en: 'here ',
                        zh: '这里 '
                    },
                    end: {
                        en: 'if the download does not start automatically!',
                        zh: '如果文件没有自动下载的话。'
                    }
                },
            },
            fail: {
                title: {
                    en: 'Download Failed',
                    zh: '下载失败'
                },
                content: {
                    en: 'Your account does not have the appropriate access to display the requested page. Please contact your Cisco account representative for further direction.',
                    zh: '下载失败'
                }
            },
            agree: {
                title: {
                    en: 'File Download Agreement',
                    zh: '文件下载协议'
                }
            }
        },
        text: {
            download: {
                en: 'Download',
                zh: '下载'
            },
            cancel: {
                en: 'Cancel',
                zh: '取消'
            },
            close: {
                en: 'Done',
                zh: '确定'
            }
        }
    }
};
